/**
 * Created by MateuszWaligora on 14.07.2017.
 */
/* eslint-disable */
import Vue from 'vue';
import * as shortid from 'shortid';
import objectPath from 'object-path';
import * as VueDeepSet from 'vue-deepset';
import {HTTPCODES} from '../../plugins/types';

/**
 * @module Store/view
 * @description Module for products
 */

/**
 * @constant State of orders store
 * @type {object}
 * */
const state = {
    templateGroups: [],
    templates: []
};

/**
 * @constant Getters
 * @type {object}
 * */
const getters = {
    getTemplateGroups: (state) => state.templateGroups,
    getTemplates: (state) => state.templates,
    getTemporaryTemplates: (state) => state.templates.filter(template => template.temporary == 'true'),
};

/**
 * @constant Mutations
 * @type {object}
 * */
const mutations = VueDeepSet.extendMutation({
    setTemplateGroups: (state, templateGroups) => state.templateGroups = templateGroups,
    addTemplateGroup: (state, group) => state.templateGroups.push(group),
    setTemplates: (state, templates) => state.templates = templates,
    addTemplate: (state, template) => state.templates.push(template),
    updateTemplateById: (state, {value, id}) => {
        let index = state.templates.findIndex(tpl => tpl.id === id);
        if(index > -1) {
            state.templates[index] = value;
        }
    }
});


/**
 * @constant Actions
 * @type {object}
 * */
const actions = {
    async getTemplateGroupsAsync ({dispatch, commit, rootState}) {
        try {
            let {data} = await Vue.axios.get(`${rootState.config.templatePort}/group`);
            commit('setTemplateGroups', data);
            return {data};
        } catch (err) {
            commit('setTemplateGroups', []);
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get template groups'
            });
            throw new Error(err);
        }
    },
    async addTemplateGroupAsync ({dispatch, commit, rootState}, templateGroup) {
        try {
            let {data} = await Vue.axios.post(`${rootState.config.templatePort}/group`, templateGroup);
            return {data};
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to add template group'
            });
            throw new Error(err);
        }
    },
    async updateTemplateGroupAsync ({dispatch, commit, rootState}, group) {
        try {
            let {data} = await Vue.axios.put(`${rootState.config.templatePort}/group/${group.id}`, group);
            return {data};
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to update template group ${group.id}`
            });
            throw new Error(err);
        }
    },
    async removeTemplateGroupAsync ({dispatch, rootState, commit}, {id}) {
        try {
            let {data} = await Vue.axios.delete(`${rootState.config.templatePort}/group/${id}`);
            return {data};
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `remove template group ${id}`
            });
            commit('setTemplateGroups', []);
            throw new Error(err);
        }
    },
    async getAllTemplatesAsync ({commit, rootState}) {
        try {
            let { data } = await Vue.axios.get(`${rootState.config.templatePort}/template`);
            commit('setTemplates', data);
            return {data};
        } catch (err) {
            commit('setTemplates', []);
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get templates'
            });
            throw new Error(err);
        }
    },
    async getTemplateByTemplateIdAsync ({commit, rootState}, {id}) {
        try {
            let { data } = await Vue.axios.get(`${rootState.config.templatePort}/template/${id}`);
            return {data};
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `get template ${id}`
            });
            throw new Error(err);
        }
    },

    async getTemplatesByGroupIdAsync ({commit, rootState}, {templateGroup}) {
        try {
            let { data } = await Vue.axios.get(`${rootState.config.templatePort}/group/${templateGroup.id}/templates`);
            return {data};
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `get templates by ${templateGroup.id} group`
            });
            throw new Error(err);
        }
    },
    async getTemplateJSONAsync ({rootState, commit}, {storeId}) {
        try {
            let { data } = await Vue.axios.get(`${rootState.config.coldStoragePort}/store/${storeId}`);
            return {data};
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `get template ${storeId}`
            });
            throw new Error(err);
        }
    },
    async addTemplateAsync ({dispatch, commit, rootState}, template) {
        try {
            let file = createTemplateFile(template);
            let body = new FormData();
            body.append('file', file);
            body.append('description', template.description);
            body.append('groupList', JSON.stringify(template.groups.map(group => group.id)));
            let { data } = await  Vue.axios.post(`${rootState.config.templatePort}/template`, body);
            return {data};
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body:  'add template'
            });
            throw new Error(err);
        }
    },
    async updateTemplateAsync ({dispatch, commit, rootState}, template) {
        try {
            let file = createTemplateFile(template);
            let body = new FormData();
            body.append('file', file);
            body.append('description', template.description);
            body.append('groupList', JSON.stringify(template.groups.map(group => group.id)));
            let { data } = await  Vue.axios.post(`${rootState.config.templatePort}/template/${template.id}`, body);
            dispatch('getAllTemplatesAsync');
            return {data};
        } catch (err) {
            dispatch('addTemplateAsync', template);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body:  'update template'
            });
            throw new Error(err);
        }
    },
    async getTemplatesGroup ({commit, rootState}, {template}) {
        try {
            let { data } = await Vue.axios.get(`${rootState.config.templatePort}/template/${template.id}/groups`);
            commit('setTemplateGroups', data);
            return {data};
        } catch (err) {
            commit('setTemplateGroups', []);
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `get template groups for ${template.id}`
            });
            throw new Error(err);
        }
    },
    async putGroupsToTemplate ({commit, rootState}, payload) {
        let groupIds = payload.groups.map(group => group.id);
        try {
            let { data } = await Vue.axios.put(`${rootState.config.templatePort}/template/${payload.id}/groups`, {groupId: groupIds});
            return {data};
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to add groups to template'
            });
            throw new Error(err);
        }
    },
    async delGroupFromTemplate ({commit, rootState}, groupId) {
        try {
            let { data } = await Vue.axios.delete(`${rootState.config.templatePort}/template/${payload.id}/groups`, {groupId: groupId});
            return {data};
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `delete group from template ${groupId}`
            });
            throw new Error(err);
        }

    },
    async getTemplatesByGroupIds ({commit, rootState}, groupId) {
        try {
            let { data } = await Vue.axios.get(`${rootState.config.templatePort}/group?groupList=[${JSON.stringify(groupId)}]`);
            return {data};
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `get templates by group ${groupId}`
            });
            throw new Error(err);
        }
    },

    async removeTemplateAsync ({commit, rootState}, {id}) {
        try {
            let { data } = await Vue.axios.delete(`${rootState.config.templatePort}/template/${id}`);
            return {data};
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `remove template ${id}`
            });
            throw new Error(err);
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};

function createTemplateFile (template) {
        if(!template) {
            return new Error('no template');
        }
        const blob = new Blob([JSON.stringify(
            [
                {
                    style: template.style,
                    groups: template.groups
                }
            ]
        )], {type: 'application/json'});
        const file = new File([blob], 'style-' + template.id + '.json', {
            type: 'application/json'
        });
        return file
}
